/**
 *    Quote
 *
 *    @tableofcontent
 *      1. Dependencies
 *      2. Functions
 *       2.1 Init
 *       2.2 Quote
 *
 */


/**
 *     @section 1. Dependencies
 */

import Constants from '../settings/_variables';


/**
 *     @section 2. Functions
 */

export default {

    // @section 2.1 Init
    init() {
        // console.log('quote loaded ...');

        this.quote();
    },

    // @section 2.2 Quote
    quote() {

        // each quote
        $(`.${Constants.prefix}quote`).each(function(i,e){
            let $quote = $(e),
                $quoteText = $quote.find(`.${Constants.prefix}quote__text`);

            // wrap span at every 'br'
            // https://stackoverflow.com/questions/19038552/jquery-wrap-text-in-a-span-before-and-after-br-within-a-paragraph
            $quoteText.contents().filter(function() {
                return this.nodeType == 3;
            }).wrap(`<span class="${Constants.prefix}quote__indent">`);

            // remove 'br' tags
            $quoteText.find('br').remove();
        });
    }
};

// end of _quote.js
